import React from 'react';
import { useDialogs, useRoutes } from '../../hooks';
import { generateGoogleMapURL } from '../../utils/api/routes';
import Button from '../Button/Button';

const OpenInMapsModal = () => {
  const { currentRoute } = useRoutes();

  const { openDialog, closeDialog } = useDialogs();

  const openMaps = () => {
    const url = generateGoogleMapURL(currentRoute.stops);
    window.open(url, '_blank');
  };

  const handleOpenInMaps = (e) => {
    const MAX_STOPS_ALLOWED = 11;

    if (currentRoute.stops.length > MAX_STOPS_ALLOWED) {
      e.preventDefault();
      openDialog({
        message: `Unfortunately google limits our stops to ${MAX_STOPS_ALLOWED}, please remove some stops and try again`,
        show: true,
        actions: [
          {
            label: 'Close',
            onClick: () => {
              closeDialog();
            },
          },
        ],
      });
      return false;
    }
    openMaps();
    return true;
  };

  return <Button label="Open in Maps" size="md" className="text-lg font-medium float-right mt-5" onClick={(e) => handleOpenInMaps(e)} />;
};

export default OpenInMapsModal;
